import React from "react";

import {
  ButtonContainer,
  CardHeader,
  Category,
  CategoryContainer,
  Circle,
  Description,
  Divider,
  PriceContainer,
  Title,
  TitleContainer,
} from "../TariffCard/styles";

import { Button, Card } from "./styles"

type TTariffCard = {
    tabType: string,
}

export const CustomCard: React.FC<TTariffCard> = ({ tabType }) => (
  <Card>
    <CardHeader tabType={tabType} />
    <CategoryContainer>
      <Circle tabType={tabType} />
      <Category>подбор услуги</Category>
    </CategoryContainer>
    <TitleContainer>
      <Title>Не знаете, что вам лучше подойдет?</Title>
    </TitleContainer>
    <Divider />
    <Description>Оставьте запрос, и мы окажем консультацию по услугам.</Description>
    <PriceContainer>
    </PriceContainer>
    <ButtonContainer>
      <Button
        href="https://t.me/ProhorovaConsult"
        target="_blank"
        rel="noopener noreferrer"
      >
        <span>Запросить консультацию</span>
      </Button>
    </ButtonContainer>
  </Card>
);

